import { useMemo } from "react"

import ClickableNameList from "#blocks/ClickableNameList"
import { type Uuid } from "#customTypes/globalTypes"
import { useGetSomeStudents } from "#hooks/jotai/useGetStudents"
import { formatStudents } from "#utils/textFormatters"

const AddClassAssistantList = ({
  onAssistantClick,
  assistantIds,
}: {
  onAssistantClick: (assistantId: Uuid) => void
  assistantIds: Uuid[]
}) => {
  const assistantsFromDb = useGetSomeStudents(assistantIds)
  const assistantsForDisplay = useMemo(() => {
    return formatStudents(assistantsFromDb)
  }, [assistantsFromDb])

  return (
    <ClickableNameList
      namesForDisplay={assistantsForDisplay}
      onClick={onAssistantClick}
      columns={1}
    />
  )
}

export default AddClassAssistantList
